/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AmsVidMappingParam } from './AmsVidMappingParam';
import {
    AmsVidMappingParamFromJSON,
    AmsVidMappingParamFromJSONTyped,
    AmsVidMappingParamToJSON,
    AmsVidMappingParamToJSONTyped,
} from './AmsVidMappingParam';

/**
 * 
 * @export
 * @interface UpdateAmsParametersRequest
 */
export interface UpdateAmsParametersRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateAmsParametersRequest
     */
    sid: number;
    /**
     * 
     * @type {Array<AmsVidMappingParam>}
     * @memberof UpdateAmsParametersRequest
     */
    mappings: Array<AmsVidMappingParam>;
}

/**
 * Check if a given object implements the UpdateAmsParametersRequest interface.
 */
export function instanceOfUpdateAmsParametersRequest(value: object): value is UpdateAmsParametersRequest {
    if (!('sid' in value) || value['sid'] === undefined) return false;
    if (!('mappings' in value) || value['mappings'] === undefined) return false;
    return true;
}

export function UpdateAmsParametersRequestFromJSON(json: any): UpdateAmsParametersRequest {
    return UpdateAmsParametersRequestFromJSONTyped(json, false);
}

export function UpdateAmsParametersRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAmsParametersRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sid': json['sid'],
        'mappings': ((json['mappings'] as Array<any>).map(AmsVidMappingParamFromJSON)),
    };
}

export function UpdateAmsParametersRequestToJSON(json: any): UpdateAmsParametersRequest {
    return UpdateAmsParametersRequestToJSONTyped(json, false);
}

export function UpdateAmsParametersRequestToJSONTyped(value?: UpdateAmsParametersRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sid': value['sid'],
        'mappings': ((value['mappings'] as Array<any>).map(AmsVidMappingParamToJSON)),
    };
}

